<form>
  <mat-form-field [appearance]="appearance" class="margin-top-1">
    <mat-label>{{label|translate}}</mat-label>
    <input class="form-control" matInput [formControl]="control" type="text" (input)="onInput($event)" type="text" [matAutocomplete]="auto"
      (click)="showPanel()">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayText" id="autocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{option[atributeDisplay]}}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="isInvalid"> {{validText|translate}}
    </mat-error>
  </mat-form-field>
</form>
